import Icon from '../components/Icon.vue'

Icon.register({"tint":{"width":1024,"height":1792,"paths":[{"d":"M512 1152q0-36-20-69-1-1-15.5-22.5t-25.5-38-25-44-21-50.5q-4-16-21-16t-21 16q-7 23-21 50.5t-25 44-25.5 38-15.5 22.5q-20 33-20 69 0 53 37.5 90.5t90.5 37.5 90.5-37.5 37.5-90.5zM1024 1024q0 212-150 362t-362 150-362-150-150-362q0-145 81-275 6-9 62.5-90.5t101-151 99.5-178 83-201.5q9-30 34-47t51-17 51.5 17 33.5 47q28 93 83 201.5t99.5 178 101 151 62.5 90.5q81 127 81 275z"}]}})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/tint.js
// module id = 1501
// module chunks = 0